import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaLeaf, FaBars } from 'react-icons/fa';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header bg-gray-800 text-white fixed top-0 left-0 w-full z-10">
      <Link to="/" className="logo-container">
        <FaLeaf className="logo" /> {/* Use the FaLeaf icon as the logo */}
      </Link>
      <FaBars className="hamburger" onClick={toggleMenu} />
      <nav className={`p-4 ${isOpen ? 'open' : ''}`}>
        <Link to="/ecosystem" className="nav-link" onClick={toggleMenu}>Ecosystem</Link>
        <Link to="/community" className="nav-link" onClick={toggleMenu}>Community</Link>
        <Link to="/governance" className="nav-link" onClick={toggleMenu}>Governance</Link>
        <Link to="/developers" className="nav-link" onClick={toggleMenu}>Developers</Link>
        <Link to="/blog" className="nav-link" onClick={toggleMenu}>Blog</Link>
        <Link to="/faq" className="nav-link" onClick={toggleMenu}>FAQ</Link>
        <Link to="/jobs" className="nav-link" onClick={toggleMenu}>Jobs</Link>
        <Link to="/launch" className="launch-app" onClick={toggleMenu}>Launch App</Link>
      </nav>
    </header>
  );
};

export default Header;
